import { render, staticRenderFns } from "./NoToursInStaticDesktop.vue?vue&type=template&id=0157ba86&"
import script from "./NoToursInStaticDesktop.vue?vue&type=script&lang=ts&"
export * from "./NoToursInStaticDesktop.vue?vue&type=script&lang=ts&"
import style0 from "./NoToursInStaticDesktop.vue?vue&type=style&index=0&id=0157ba86&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports